#version 300 es
precision highp float;

layout(location=0)in vec2 a_particle_pos;

uniform sampler2D u_wind;
uniform vec2 u_wind_res;
//uniform vec2 u_wind_min;
//uniform vec2 u_wind_max;
uniform float u_rand_seed;
uniform float u_speed_factor;
uniform float u_constant_speed;
uniform float u_drop_rate;
uniform float u_drop_rate_bump;
uniform float u_display_aspect_ratio;

uniform vec2 u_x_range;
uniform vec2 u_y_range;

uniform float u_north_lat;
uniform float u_south_lat;
uniform float u_north_merc_y;
uniform float u_south_merc_y;

const float PI=3.14159265359;

// pseudo-random generator
const vec3 rand_constants=vec3(12.9898,78.233,4375.85453);
float rand(const vec2 co){
    float t=dot(rand_constants.xy,co);
    return fract(sin(t)*(rand_constants.z+t));
}

vec2 from_mercator(vec2 xy){
    float y=u_north_merc_y+xy.y*(u_south_merc_y-u_north_merc_y);
    y=radians(180.-y*360.);
    y=360./PI*atan(exp(y))-90.;
    y=(y-u_north_lat)/(u_south_lat-u_north_lat);
    
    return vec2(xy.x,y);
}

// wind speed lookup; use manual bilinear filtering based on 4 adjacent pixels for smooth interpolation
vec2 lookup_wind(const vec2 uv){
    //return texture(u_wind, uv).rg; // lower-res hardware filtering
    vec2 px=1./u_wind_res;
    vec2 vc=(floor(uv*u_wind_res))*px;
    vec2 f=fract(uv*u_wind_res);
    vec2 tl=texture(u_wind,vc).rg;
    vec2 tr=texture(u_wind,vc+vec2(px.x,0)).rg;
    vec2 bl=texture(u_wind,vc+vec2(0,px.y)).rg;
    vec2 br=texture(u_wind,vc+px).rg;
    return mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);
}

vec2 calc_data_pos(vec2 pos){
    float x=(pos.x-u_x_range[0])/(u_x_range[1]-u_x_range[0]);
    float y=(pos.y-u_y_range[0])/(u_y_range[1]-u_y_range[0]);
    
    return vec2(x,y);
}

void main(){
    vec2 pos=a_particle_pos.rg;

    vec2 data_pos=calc_data_pos(pos);

    float out_of_bounds=pos.x<0.001||pos.x>0.999||pos.y<0.001||pos.y>0.999?1.:0.;

    vec2 velocity = lookup_wind(data_pos);
    float speed_t = length(velocity);
    // u_constant_speedを使って最低速度を設定
    float constant_speed = step(u_constant_speed, speed_t);
    velocity = mix(velocity, normalize(velocity) * u_constant_speed, 1.0 - constant_speed);

    vec2 offset=vec2(velocity.x,-velocity.y)*.0004*u_speed_factor;
    offset.x*=u_display_aspect_ratio;

    // update particle position, wrapping around the date line
    pos=fract(1.+pos+offset);

    // a random seed to use for the particle drop
    vec2 seed=(pos+a_particle_pos.rg)*u_rand_seed;

    // drop rate is a chance a particle will restart at random position, to avoid degeneration
    float drop_rate=u_drop_rate+speed_t*u_drop_rate_bump;
    
    float drop = step(1.-drop_rate,rand(seed)) + (1.-step(.1,speed_t)) + out_of_bounds;
    drop = clamp(drop, 0.0, 1.0);

    vec2 random_pos=vec2(
        rand(seed+1.3),
        rand(seed+2.1));
    pos=mix(pos,random_pos,drop);

    velocity=mix(velocity,vec2(0.),out_of_bounds);
    speed_t=length(velocity);

    vec2 diff=mix(velocity,vec2(0.),drop);

    gl_Position=vec4(pos,diff);
}
